import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig, sizes } from '../config'
import Pagination from './Pagination'

const parseInteger = (value) =>
    value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0

export default () => {
    const { query, response } = useAppState()
    const { updateSearch } = useActions()

    const from = parseInteger(query.products?.from)
    const size = parseInteger(response.products.size)
    const total = parseInteger(response.products.total)
    const to = Math.min(from + size, total);

    const sizeOptions = [...sizes]
        .reverse()
        .filter((value) => value <= total * 2)

    return (
        <div class="plp-toolbar">
            <div class="plp-toolbar--pagination-info">
                <div>
                    {from + 1} - {to} of {total} items
                </div>
                {sizeOptions.length > 0 && (
                    <div>
                        <select
                            name="page_size"
                            id="page_size"
                            class="sidebar-select"
                            value={size}
                            onChange={(e) => {
                                updateSearch({
                                    products: {
                                        size: e?.target?.value
                                    },
                                })
                            }}
                        >
                            {sizeOptions.map((v) => (
                                <option value={v}>{v} per page</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
            <Pagination />
        </div>
    )
}
